<template>
	<CharacteristicEdit
		:value="value"
		:characteristic-items="meta.functionMarketingRole"
		:characteristic-type="meta.functionMarketingRoleType"
		title="Marketingtätigkeiten (Vorerfahrung)"
		:supplements-config="{
			disable: true
		}"
		:nothing-allowed="{
			onlyOverall: true,
			overall: {
				text: 'Es ist keine Vorerfahrung nötig'
			}
		}"
		:experience-config="{
			noneAllowed: false
		}"
		:selectedItemsConfig="{
			labelType: labelTypeJobProfile
		}"
		:additions-config="{
			type: 'customer'
		}"
		label-set="customer"
		:label-type="labelTypeJobProfile"
		open-fan-label="Hinzufügen"
		open-fan-label-with-selection="Bearbeiten"
		open-fan-button-alignment="left"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import CharacteristicEdit from "@/vue/characteristic/Edit";
import {JOB_PROFILE} from "@/helper/characteristic/Label";

export default {

	components: {
		CharacteristicEdit
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
	},

	computed: {
		labelTypeJobProfile ()
		{
			return JOB_PROFILE;
		}
	}
}
</script>
